import { Link } from "react-router-dom";

const footerNav = [
  { to: "/", label: "首页" },
  { to: "/updates", label: "更新动态" },
  { to: "/series", label: "追更书架" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

const categoryLinks = ["热血", "冒险", "恋爱", "悬疑", "玄幻", "都市"];

export default function SiteFooter() {
  return (
    <footer className="mt-auto border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2" aria-label="66漫画网 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-primary-700">66漫画网</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              66漫画网专注呈现漫画更新动态，实时掌握最新话、今天更新、补更与断更等进度，帮助每一位追更读者不再错过精彩内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-tiktok-line", "ri-douban-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  aria-label={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-display text-base text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-base text-foreground-900">热门分类</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categoryLinks.map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/series?category=${encodeURIComponent(cat)}`}
                    className="inline-block rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-accent-500 hover:text-background-50"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <p className="text-sm text-foreground-600">联系与合作</p>
              <a
                href="mailto:hello@66mangawang.com"
                className="mt-1 inline-flex items-center gap-2 text-sm text-primary-600 hover:underline"
              >
                <i className="ri-mail-line"></i>hello@66mangawang.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 66漫画网 · 追更必备 · 动态实时掌握
          </p>
          <p className="text-xs text-foreground-500">
            本站仅作漫画更新动态整理与进度追踪
          </p>
        </div>
      </div>
    </footer>
  );
}